import {
  CUSTOMER_LABELS_TYPE,
  LOAD_STATE,
  POST_DELIVERY_LOAD_STATES,
} from 'apps/fleet-planner/constants/loads'

export const toggleTargetDedicated = (labels: CUSTOMER_LABELS_TYPE[]) => {
  const hasTargetDedicated = labels.includes(CUSTOMER_LABELS_TYPE.TARGET_DEDICATED)
  return hasTargetDedicated
    ? labels.filter(label => label !== CUSTOMER_LABELS_TYPE.TARGET_DEDICATED)
    : [...labels, CUSTOMER_LABELS_TYPE.TARGET_DEDICATED]
}

export const obscurePostDeliveryStatus = (
  loadStatus: LOAD_STATE,
  isExternal: boolean | undefined
) => {
  if (!isExternal) return loadStatus
  if (loadStatus in POST_DELIVERY_LOAD_STATES) {
    return LOAD_STATE.Delivered
  }
  return loadStatus
}
